export enum EddStatus {
  UNINITIATED = "UNINITIATED",
  INITIATED = "INITIATED",
  RESUBMISSION_REQUESTED = "RESUBMISSION_REQUESTED",
  VERIFICATION_IN_PROGRESS = "VERIFICATION_IN_PROGRESS",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED"
}

export enum UpgradeLimitState {
  IDLE = "idle",
  LOADING = "loading",
  ERROR = "error"
}

export type EddStatusType = keyof typeof EddStatus;

export interface EddStatusResponse {
  status: EddStatusType;
  message: string;
  info: string;
  eta: number;
}

export interface EddProgressResponse {
  sections?: Array<{ tag?: string; status?: string; [key: string]: unknown }>;
  progress?: number;
}
